import React, { useState, useEffect } from 'react';
import { fetchStudents, handleAddAssessment, fetchAssessments } from '../ApiHandler/studentFunctions';
import { fetchActiveLabs } from '../ApiHandler/labFunctions';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StudentAssessments = ({ role }) => {
    const initialState = {
        student_id: '',
        lab_id: '', 
        pre_max_marks: '',
        pre_obtained_marks: '',
        mid_max_marks: '',
        mid_obtained_marks: '',
        post_max_marks: '',
        post_obtained_marks: '',
        remarks: ''
    };
    const [formData, setFormData] = useState(initialState);
    const [students, setStudents] = useState([]);
    const [labs, setLabs] = useState([]);
    const [assessments, setAssessments] = useState([]);
    const [selectedLabId, setSelectedLabId] = useState('');

    useEffect(() => {
        fetchStudents(setStudents);
        fetchActiveLabs(setLabs);
        fetchAssessments(setAssessments);
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleLabChange = (e) => {
        const labId = e.target.value;
        setSelectedLabId(labId);
        setFormData({ ...formData, lab_id: labId, student_id: '' });
    };

    const handleStudentSelect = (e) => {
        const studentId = e.target.value;
        const selectedStudent = students.find(s => String(s.id) === String(studentId));
        setFormData({ 
            ...formData, 
            student_id: studentId,
            lab_id: selectedStudent ? selectedStudent.lab_id : selectedLabId
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.student_id) {
            toast.error("Please select a student first.");
            return;
        }
        await handleAddAssessment(formData, setFormData);
        fetchAssessments(setAssessments);
    };

    const filteredStudents = selectedLabId 
        ? students.filter(s => String(s.lab_id) === String(selectedLabId))
        : students;
    const studentOptions = filteredStudents.map(student => ({
        value: student.id,
        label: `${student.first_name || ''} ${student.last_name || ''} (ID: ${student.id} - ${student.course_opted || 'No Exam'})`.trim()
    }));

    return (
        <main>
            <style>{`
                input[type="number"]::-webkit-inner-spin-button,
                input[type="number"]::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
                input[type="number"] {
                    -moz-appearance: textfield;
                }
            `}</style>
            <ToastContainer />
            <div className="head-title">
                <div className="left">
                    <h1 style={{ fontSize: '24px', fontWeight: 'bold' }}>Student Assessment</h1>
                </div>
            </div>

            <div className="table-data" style={{ marginTop: '20px' }}>
                <div className="order" style={{ padding: '30px', backgroundColor: '#fff', borderRadius: '15px' }}>
                    <form onSubmit={handleSubmit}>
                        
                        <div className='responsive-grid-2' style={{marginBottom: '30px'}}>
                            <div>
                                <label style={labelStyle}>Select Lab</label>
                                <select 
                                    value={selectedLabId} 
                                    onChange={handleLabChange} 
                                    style={inputStyle}
                                >
                                    <option value="">-- All Labs / No Lab --</option>
                                    {labs.map(lab => (
                                        <option key={lab.id} value={lab.id}>{lab.lab_name}</option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label style={labelStyle}>Select Student *</label>
                                <Select 
        options={studentOptions}
        value={studentOptions.find(opt => String(opt.value) === String(formData.student_id)) || null}
        onChange={(selected) => {
            const studentId = selected ? selected.value : '';
            const selectedStudent = students.find(s => String(s.id) === String(studentId));
            const existingAssessment = assessments.find(a => String(a.student_id) === String(studentId));
            
            if (existingAssessment) {
                setFormData({
                    student_id: studentId,
                    lab_id: existingAssessment.lab_id || selectedLabId,
                    pre_max_marks: existingAssessment.pre_max_marks || '',
                    pre_obtained_marks: existingAssessment.pre_obtained_marks || '',
                    mid_max_marks: existingAssessment.mid_max_marks || '',
                    mid_obtained_marks: existingAssessment.mid_obtained_marks || '',
                    post_max_marks: existingAssessment.post_max_marks || '',
                    post_obtained_marks: existingAssessment.post_obtained_marks || '',
                    remarks: existingAssessment.remarks || ''
                });
            } else {
                setFormData({ 
                    ...initialState, 
                    student_id: studentId,
                    lab_id: selectedStudent ? selectedStudent.lab_id : selectedLabId
                });
            }
        }}
        placeholder="-- Search or Select Student --"
        isClearable
    />
                            </div>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '30px' }}>
                            {/* Pre Assessment */}
                            <div style={cardStyle}>
                                <h4>Pre Assessment</h4>
                                <div style={{ marginTop: '15px' }}>
                                    <label style={labelStyle}>Max Marks</label>
                                    <input type="number" step="0.01" name="pre_max_marks" value={formData.pre_max_marks} onChange={handleInputChange} onWheel={(e) => e.target.blur()} style={inputStyle} />
                                </div>
                                <div style={{ marginTop: '15px' }}>
                                    <label style={labelStyle}>Obtained Marks</label>
                                    <input type="number" step="0.01" name="pre_obtained_marks" value={formData.pre_obtained_marks} onChange={handleInputChange} onWheel={(e) => e.target.blur()} style={inputStyle} />
                                </div>
                            </div>

                            {/* Mid Assessment */}
                            <div style={cardStyle}>
                                <h4>Mid Assessment</h4>
                                <div style={{ marginTop: '15px' }}>
                                    <label style={labelStyle}>Max Marks</label>
                                    <input type="number" step="0.01" name="mid_max_marks" value={formData.mid_max_marks} onChange={handleInputChange} onWheel={(e) => e.target.blur()} style={inputStyle} />
                                </div>
                                <div style={{ marginTop: '15px' }}>
                                    <label style={labelStyle}>Obtained Marks</label>
                                    <input type="number" step="0.01" name="mid_obtained_marks" value={formData.mid_obtained_marks} onChange={handleInputChange} onWheel={(e) => e.target.blur()} style={inputStyle} />
                                </div>
                            </div>

                            {/* Post Assessment */}
                            <div style={cardStyle}>
                                <h4>Post Assessment</h4>
                                <div style={{ marginTop: '15px' }}>
                                    <label style={labelStyle}>Max Marks</label>
                                    <input type="number" step="0.01" name="post_max_marks" value={formData.post_max_marks} onChange={handleInputChange} onWheel={(e) => e.target.blur()} style={inputStyle} />
                                </div>
                                <div style={{ marginTop: '15px' }}>
                                    <label style={labelStyle}>Obtained Marks</label>
                                    <input type="number" step="0.01" name="post_obtained_marks" value={formData.post_obtained_marks} onChange={handleInputChange} onWheel={(e) => e.target.blur()} style={inputStyle} />
                                </div>
                            </div>
                        </div>

                        <div style={{ marginBottom: '30px' }}>
                            <label style={labelStyle}>Remarks</label>
                            <input 
                                type="text" 
                                name="remarks" 
                                value={formData.remarks} 
                                onChange={handleInputChange} 
                                style={inputStyle} 
                            />
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '15px' }}>
                            <button 
                                type="button" 
                                onClick={() => setFormData(initialState)} 
                                style={{ ...btnStyle, backgroundColor: '#d1d5db', color: '#374151' }}
                            >
                                Clear
                            </button>
                            <button 
                                type="submit" 
                                style={{ ...btnStyle, backgroundColor: '#8b5cf6' }}
                            >
                                Save Assessment
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div className="table-data" style={{ marginTop: '20px' }}>
                <div className="order" style={{ padding: '30px', backgroundColor: '#fff', borderRadius: '15px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h3>Registered Students</h3>
                    </div>
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px', fontSize: '14px' }}>
                            <thead style={{ backgroundColor: '#f9f9f9', textAlign: 'left', borderBottom: '2px solid #ddd' }}>
                                <tr>
                                    <th style={{ padding: '12px 15px' }}>ID</th>
                                    <th style={{ padding: '12px 15px' }}>Name</th>
                                    <th style={{ padding: '12px 15px' }}>Kendra / Lab</th>
                                    <th style={{ padding: '12px 15px' }}>Exam</th>
                                    <th style={{ padding: '12px 15px' }}>Pre (Obt/Max)</th>
                                    <th style={{ padding: '12px 15px' }}>Mid (Obt/Max)</th>
                                    <th style={{ padding: '12px 15px' }}>Post (Obt/Max)</th>
                                    <th style={{ padding: '12px 15px', textAlign: 'center' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredStudents.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>No students found matching your criteria.</td>
                                    </tr>
                                ) : (
                                    filteredStudents.map(student => {
                                        const assessment = assessments.find(a => String(a.student_id) === String(student.id)) || {};
                                        return (
                                            <tr key={student.id} style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '12px 15px' }}>{student.id}</td>
                                                <td style={{ padding: '12px 15px', fontWeight: 'bold' }}>{student.first_name} {student.last_name}</td>
                                                <td style={{ padding: '12px 15px' }}>{student.kendra_name || student.lab_name || '-'}</td>
                                                <td style={{ padding: '12px 15px' }}>{student.course_opted || '-'}</td>
                                                <td style={{ padding: '12px 15px' }}>
                                                    {assessment.pre_max_marks ? `${assessment.pre_obtained_marks || '-'}/${assessment.pre_max_marks}` : '-'}
                                                </td>
                                                <td style={{ padding: '12px 15px' }}>
                                                    {assessment.mid_max_marks ? `${assessment.mid_obtained_marks || '-'}/${assessment.mid_max_marks}` : '-'}
                                                </td>
                                                <td style={{ padding: '12px 15px' }}>
                                                    {assessment.post_max_marks ? `${assessment.post_obtained_marks || '-'}/${assessment.post_max_marks}` : '-'}
                                                </td>
                                                <td style={{ padding: '12px 15px', textAlign: 'center' }}>
                                                    <button 
                                                        onClick={() => {
                                                            setSelectedLabId(student.lab_id || '');
                                                            setFormData({
                                                                student_id: student.id,
                                                                lab_id: student.lab_id,
                                                                pre_max_marks: assessment.pre_max_marks || '',
                                                                pre_obtained_marks: assessment.pre_obtained_marks || '',
                                                                mid_max_marks: assessment.mid_max_marks || '',
                                                                mid_obtained_marks: assessment.mid_obtained_marks || '',
                                                                post_max_marks: assessment.post_max_marks || '',
                                                                post_obtained_marks: assessment.post_obtained_marks || '',
                                                                remarks: assessment.remarks || ''
                                                            });
                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                        }}
                                                        style={{ backgroundColor: '#10b981', color: 'white', border: 'none', padding: '6px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}
                                                    >
                                                        Assess
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', borderLeft: '4px solid #6C5CE7', fontSize: '13px', color: '#555' }}>
                <i className='bx bx-shield-quarter' style={{ marginRight: '8px', color: '#6C5CE7' }}></i>
                <strong>Role-Based Access:</strong> To ensure data privacy, Teachers can only view records mapped to their assigned Lab or School, or records they have personally added. District Officers can view all records within their assigned District. Admin has global access.
            </div>
        </main>
    );
};

const labelStyle = {
    display: 'block',
    marginBottom: '8px',
    fontWeight: '500',
    color: '#333'
};

const inputStyle = {
    width: '100%',
    padding: '12px 15px',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
    outline: 'none',
    backgroundColor: '#f9fafb',
    fontSize: '14px'
};

const cardStyle = {
    padding: '20px',
    border: '1px solid #e5e7eb',
    borderRadius: '10px',
    backgroundColor: '#fff'
};

const btnStyle = {
    padding: '10px 25px',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600'
};

export default StudentAssessments;
